import * as yup from 'yup';

export const supportTicketSchema = yup.object({
	ScorecardId: yup.string().nullable().required('Scorecard is required'),
	TypeId: yup.string().nullable().required('Type is required'),
	Description: yup
		.string()
		.nullable()
		.required('Description is required')
		.max(950, 'Max character limit of 950 reached'),
});
